/**
 * Entry point for the main Javascript to this Application
 */

// Polyfills

/*import 'babel-polyfill'*/
import 'classlist-polyfill'
import 'custom-event-polyfill'
import './modules/polyfills/MatchesSelectorPolyfill'
import './modules/polyfills/ForEachPolyfill'

// Modules
import './modules/CookieConsent'
import './modules/IsTouchDevice'
import './modules/IsBrowserIE9'
import './modules/IsBrowserIE10'
import './modules/DeferredImages'
import './modules/UserTabbing'
import './modules/MobileNav'
import './modules/HeaderSecondaryNav'
// import './modules/MegaMenu'
import './modules/Modal'
import './modules/SuperSearch'
import './modules/Accordion'
import './modules/RangeSlider'
import './modules/MobileResultsFilter'
import Slider from './modules/Slider'

import './modules/Shortlist'
import './modules/ShortlistAPI'

import './modules/forms/FormValidation'
import './modules/forms/AccesOrCreateAccount'
import './modules/FindCottage'
import './modules/Results'

import './modules/Reviews'
import './modules/Reviews.ReadMore'

import './modules/Availability'
import './modules/SliderResults'
import './modules/Tooltips'
import './modules/bookingsummary/BookingSummary'
import './modules/bookingsummary/BookingSummaryLineItem'
import './modules/FlexibleBooking'
import './modules/Reservation'


import './modules/ArrivalMap'
import './modules/ExploreNearby'
import './modules/Newsletter'
import './modules/SocialShare'
import './modules/Blog'
import './modules/OwnersContact'
import './modules/OwnersLocation'
import './modules/RoomConfig'

import './modules/FindAddress'
import './modules/StarRating'
import './modules/myclassic/MyClassic'
import './modules/GuideReviewModal'

import './modules/Questionnaire'
import './modules/TawkChat'
import './modules/FeaturedProperties'

import './modules/PaymentSchedule'
// Legacy modules 
// This code has been broken out from previous js,
// would be good to refactor as most clutter the`window` namespace **
import './modules/forms/PopDependantDDL'


(() => {
    // Instantiate GTM data layer
    window.dataLayer = window.dataLayer || []
    window.dataLayerQueue = window.dataLayerQueue || []

    // Instantiate sliders
    const sliders = document.querySelectorAll('.slider:not([data-defer-slider=""])');
    Array.from(sliders).forEach((element) => {
        const options = {}
        if (element.classList.contains('slider--properties') === true) {
            options.navTemplate = '<a href="#"><svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0006 0L0.62545 11.1186L2.59462 13.0741L12.0006 3.8808L26.0308 17.595L28 15.6395L12.0006 0Z" /><path d="M20.9976 27V15.4287L23.7939 18.251V27H20.9976Z"/></svg><span>{index}</span></a>'
        }
        new Slider(element, options);
    })

})()
